import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Import Bootstrap Icons
import './Bdashboard.css'; // Use the new, professional CSS below
import logo from '../Logo/logo2-Photoroom.png'; 

// Updated navItems to use Bootstrap Icon class names
const navItems = [
  { label: 'Dashboard', icon: 'bi-grid-1x2', path: '/broker/dashboard'},
  // { label: 'Forms', icon: 'bi-receipt', path: '/broker/invoice' },
  { label: 'Profile', icon: 'bi-person', path: '/broker/profile' }
];

const Bdashboard = () => {
  const location = useLocation();

const handleLogout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  sessionStorage.clear();
  window.location.href = '/';
};
  return (
    <nav className="dashboard-sidebar">
     <img src={logo} alt="Logo" style={{height:"100px", width:"100px", marginLeft:"45px"}}/> 
      <hr />
      <ul className="nav-list">
        {navItems.map((item) => (
          <li className="nav-item" key={item.label}>
            {item.path && !item.disabled ? (
              <Link
                to={item.path}
                // Dynamically add 'active' class based on the current URL
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </Link>
            ) : (
              // Use a <span> for disabled items for better semantics
              <span className="nav-link disabled">
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </span>
            )}
          </li>
        ))}
      </ul>
      <div className="logout-section">
        <button type="button" className="nav-link logout-button" onClick={handleLogout} style={{background : "red", border: "none", color: "white"}}>
          <i className="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default Bdashboard;